import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDensityStandardIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "-2 -3 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11 5.5H1C0.734784 5.5 0.48043 5.60536 0.292893 5.79289C0.105357 5.98043 0 6.23478 0 6.5V9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H11C11.2652 10 11.5196 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9V6.5C12 6.23478 11.8946 5.98043 11.7071 5.79289C11.5196 5.60536 11.2652 5.5 11 5.5ZM11 9H1V6.5H11V9ZM11 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V3.5C0 3.76522 0.105357 4.01957 0.292893 4.20711C0.48043 4.39464 0.734784 4.5 1 4.5H11C11.2652 4.5 11.5196 4.39464 11.7071 4.20711C11.8946 4.01957 12 3.76522 12 3.5V1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0ZM11 3.5H1V1H11V3.5Z" })
});
export default SvgDensityStandardIcon;
